module.exports = __webpack_public_path__ + "img/7.a0ed3f9e.jpg";